module.exports = __webpack_public_path__ + "media/Alert 5.5a70ff55.mp3";